import React from 'react';
import { RefreshCw, Trophy } from 'lucide-react';
import { TIER_COLORS } from '../lib/tierColors';

export default function RankBadge({ settings, onRefresh, refreshing }) {
  if (!settings || !settings.current_tier) {
    return null;
  }

  const tier = settings.current_tier;
  const rank = settings.current_rank;
  const lp = settings.current_lp;
  const color = TIER_COLORS[tier] || '#71717a';
  const isElite = ['MASTER', 'GRANDMASTER', 'CHALLENGER'].includes(tier);

  return (
    <div className="flex items-center gap-2 border px-3 py-2" style={{ borderColor: `${color}50`, background: `${color}08` }}>
      <Trophy size={12} style={{ color }} />
      <div className="flex flex-col">
        <div className="text-[9px] tracking-[0.3em] text-zinc-500 uppercase font-semibold leading-none">SoloQ</div>
        <div className="font-black text-sm" style={{ color }}>
          {tier[0]}{tier.slice(1).toLowerCase()}
          {!isElite && rank && ` ${rank}`}
          <span className="text-white font-mono ml-1">{lp}LP</span>
        </div>
      </div>
      <button
        onClick={onRefresh}
        disabled={refreshing}
        className="text-zinc-500 hover:text-cyan-400 transition disabled:opacity-50"
        title="Rafraîchir le rang"
      >
        <RefreshCw size={11} className={refreshing ? 'animate-spin' : ''} />
      </button>
    </div>
  );
}
